"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DefaultIcon_1 = __importDefault(require("./icons/DefaultIcon"));
const IconType_1 = __importDefault(require("./enums/IconType"));
const ColorType_1 = __importDefault(require("./enums/ColorType"));
const ArrowButton = (props) => {
    return (react_1.default.createElement("button", { onClick: () => props.handlerFunction(), className: "arrow-button", type: "button" },
        react_1.default.createElement("div", { className: `arrow-button__content--${props.direction}` },
            react_1.default.createElement(DefaultIcon_1.default, { size: "24", type: props.direction === "left"
                    ? IconType_1.default.ArrowLeft
                    : IconType_1.default.ArrowRight, color: ColorType_1.default.Green }),
            react_1.default.createElement("p", { className: "arrow-button__label" }, props.label))));
};
exports.default = ArrowButton;
